import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import WithScrollToTop from 'app/hocs/with-scroll-to-top';
import history from 'app/utils/history';
import Routes from 'app/routes';

const Root = ({ store }) => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <WithScrollToTop>
          <Routes />
        </WithScrollToTop>
      </ConnectedRouter>
    </Provider>
  );
};

export default Root;



// WEBPACK FOOTER //
// ./src/root.js